import { getSecret } from "./get-secret.js";
import sendgrid from "@sendgrid/mail";
import { SQSClient, SendMessageCommand } from "@aws-sdk/client-sqs";
import { env } from "../../server/env.js";
const sqsClient = new SQSClient();
let SENDGRID_API_KEY = "";
export async function sendEmail(sendEmailParams) {
    if (!SENDGRID_API_KEY) {
        ({ SENDGRID_API_KEY } = await getSecret("SENDGRID_API_KEY"));
    }
    sendgrid.setApiKey(SENDGRID_API_KEY);
    const params = {
        to: sendEmailParams.to,
        from: sendEmailParams.from,
        subject: sendEmailParams.subject,
        text: sendEmailParams.text,
        html: sendEmailParams.html,
        dynamicTemplateData: sendEmailParams.dynamicTemplateData ?? {},
    };
    // base 64 email for unsubscribe link
    let base64email = "";
    if (Object.keys(params.dynamicTemplateData).length) {
        if (typeof params.to === "string") {
            base64email = Buffer.from(params.to, "utf8").toString("base64");
        }
        else if (params.to.length === 1) {
            base64email = Buffer.from(params.to[0], "utf8").toString("base64");
        }
        else if (params.to.email) {
            base64email = Buffer.from(params.to.email, "utf8").toString("base64");
        }
    }
    const { sendAt, bcc, templateId } = sendEmailParams;
    if (sendAt) {
        params.sent_at = sendAt;
    }
    if (bcc?.length) {
        params.bcc = bcc;
    }
    if (templateId) {
        params.templateId = templateId;
    }
    if (env.ENV !== "production") {
        params.to = "boadevtest@gmail.com";
        params.bcc = undefined;
        base64email = Buffer.from(params.to, "utf8").toString("base64");
    }
    params.dynamicTemplateData.base64email = base64email;
    const [response] = await sendgrid.send(params);
    return response;
}
;
export async function queueEmail(params) {
    const { to, bcc = [], from, subject, text, html, sendAt = "", templateId, dynamicTemplateData = {} } = params;
    return sqsClient.send(new SendMessageCommand({
        QueueUrl: env.EMAIL_QUEUE_URL,
        MessageBody: JSON.stringify({
            to,
            bcc,
            from,
            subject,
            text,
            html,
            sendAt,
            templateId,
            dynamicTemplateData,
        }),
    }));
}
//# sourceMappingURL=send-email.js.map